module.exports = __webpack_public_path__ + "static/media/higuchi-building-3.5315ae0e.jpg";